import i18n from "i18next";

type LanguageVersions = {
  [key: string]: {
    pdf: string;
    content: string;
  };
};

const languageVersions: LanguageVersions = {
  enUS: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/en/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/en/summary.html",
  },
  bgBG: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/en/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/en/summary.html",
  },
  ptPT: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/pt/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/pt/summary.html",
  },
  es: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/es/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/es/summary.html",
  },
  de: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/de/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/de/summary.html",
  },
  pl: {
    pdf: "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/pl/tc.pdf",
    content:
      "https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/pl/summary.html",
  },
};

export const getCardAgreementLinks = () => {
  let language = i18n.language;
  language = language?.split("-")[0] ?? "en";

  return {
    content: `https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/${language}/card-agreement/cha.html`,
    pdf: `https://test-terms-and-conditions.s3.eu-central-1.amazonaws.com/${language}/card-agreement/cha.pdf`,
  };
};

export const getTermsAndConditionsLinks = () => {
  let language = i18n.language;
  language = language?.replace("-", "") ?? "";

  return languageVersions[language] ?? languageVersions["enUS"];
};
